// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wordfall-android{\n  width: auto;\n  margin: 5% auto; \n}", "",{"version":3,"sources":["webpack://./src/components/Projects/WordFall/WordFall.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[".wordfall-android{\n  width: auto;\n  margin: 5% auto; \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
